<template>
  <div class="jl-auc-success-wrap">
    <div class="jl-container">
      <div class="jl-auc-success-content">
        <img src="../../assets/img/zkj-success-shop.png" alt />
        <p class="text1">恭喜您下单成功</p>
        <div class="item-footer">
          <!-- <button class="item-btn" @click="goToDetail">商品详情</button> -->
          <button class="item-btn active" @click="linkOrder">查看订单</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "orderSuccess",
  data() {
    return {};
  },
  created() {},
  methods: {
    linkOrder() {
      this.$router.push({
        name: "order"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc-success-wrap {
  background: #fff;
  padding-bottom: 180px;
}
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.jl-breadcrumb {
  padding: 14px 0;
}
.jl-breadcrumb-list {
  .item {
    display: inline-block;
    vertical-align: middle;
    > a {
      font-size: 14px;
      color: #8b8b8b;
      &.active {
        color: #e50011;
      }
    }
  }
}
.jl-auc-success-content {
  padding-top: 100px;
  text-align: center;
  .text1 {
    font-size: 24px;
    color: #333;
    margin-bottom: 30px;
    margin-top: 18px;
    font-weight: bold;
  }
  .text2 {
    font-size: 14px;
    color: #e50011;
    margin-bottom: 40px;
  }
  .item-footer {
    .item-btn {
      width: 128px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      font-size: 16px;
      color: #333;
      border: 1px solid #666;
      margin: 0 10px;
      background-color: #fff;
      cursor: pointer;
      &.active {
        color: #fff;
        border-color: #e50011;
        background-color: #e50011;
      }
    }
  }
}
</style>
